import { useAuthStore } from '@store/index';

/**
 * Where a "home" link on a page open to signed-out visitors should go.
 *
 * REV-939 review: "/" is a signed-in route (ui#279), so a "home" link sent a
 * signed-out visitor to the sign-in page under a label that promised the
 * dashboard. Signed out, these links go to sign-in and say so; signed in,
 * nothing changes.
 */
export function useHomeDestination(): { to: string; signedIn: boolean } {
  const signedIn = useAuthStore((s) => s.isAuthenticated);
  return { to: signedIn ? '/' : '/login', signedIn };
}
